module.exports = __webpack_public_path__ + "static/media/best_dish.b1eb7cdd.png";